import React from 'react'
import { ReloadOutlined } from '@ant-design/icons'
import { Button, message, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import EmptyContent from '../EmptyContent'
import { find } from 'lodash-es'
import { TRUC_COMMAND } from '../../command_constant'

const RefreshTrucButton = props => {
  const { Option } = Select

  const { authenticationStore, loadingAnimationStore, accountStore } = props
  const { accountList } = accountStore

  const refreshTrucAccount = async () => {
    loadingAnimationStore.showSpinner(true)

    authenticationStore.logoutTruc()
    await accountStore.getCurrentUserAccount()

    loadingAnimationStore.showSpinner(false)
    message.success('Đã làm mới lại liên kết tới trục')
  }

  const onAccountChange = async accountId => {
    try {
      loadingAnimationStore.showSpinner(true)
      await accountStore.setActiveAccount(accountId)

      await refreshTrucAccount()
    } catch (e) {
      message.error(e.vi)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <>
      <Button onClick={refreshTrucAccount}>
        <ReloadOutlined />
        Làm mới
      </Button>

      <Select
        style={{ width: 180 }}
        notFoundContent={<EmptyContent />}
        onChange={onAccountChange}
        value={
          find(
            accountList.filter(item => item.command.code === TRUC_COMMAND),
            { is_active: true }
          )?.id
        }
        placeholder={'Chọn tài khoản trục'}>
        {accountList
          .filter(item => item.command.code === TRUC_COMMAND)
          .map(item => (
            <Option key={item.id} value={item.id}>
              {item.alias}
            </Option>
          ))}
      </Select>
    </>
  )
}

RefreshTrucButton.propTypes = {}

export default withRouter(
  inject(
    'loadingAnimationStore',
    'authenticationStore',
    'accountStore'
  )(observer(RefreshTrucButton))
)
